// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2LWDm","content":"styles_content__3dXPQ","checkbox":"styles_checkbox__-aQay","checkboxLabel":"styles_checkboxLabel__2KI7b"};